import { Divider, Grid, Tooltip } from "@mui/material";
import { useContext } from "react";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import animationData from "../../../../assets/lotties/Arrow_Plan.json";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import images and icons
import noImage from "../../../../assets/imgs/no-image.png";
import Icon from "../../../common/base-icon/icon";
import { ArrowSwapHorizontal } from "iconsax-react";

//import styles
import "./itinerary-item.scss";

function ItineraryItem({ info, handleDescriptionModal, handleReplaceModal, index, length }) {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const isExpire = new Date() > new Date(info.custom_start_time);

    //lotties
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <Grid container item xs={12}>
            <Grid className="itinerary-item" container item xs={10} rowGap={1}>
                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <img className="itinerary-item__photo" src={info.image === "" ? noImage : "https://api.atripa.com" + info.image} alt=""></img>
                </Grid>

                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <span className="itinerary-item__name" data-text={locale === "en" ? info.name1 : info.name2}>
                        {locale === "en" ? info.name1 : info.name2}
                    </span>
                </Grid>

                <Grid container item xs={12} justifyContent="space-around" alignItems="center">
                    <span>{info.start_time.substr(0, 2) + ":" + info.start_time.substr(2, 2)}</span>
                    <Grid container item xs={4}>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--teal-color-18)" }} />
                    </Grid>
                    <span>{info.end_time.substr(0, 2) + ":" + info.end_time.substr(2, 2)}</span>
                </Grid>

                <Grid className="itinerary-item__points" container item xs={12} columnGap={1} justifyContent="center" alignItems="center">
                    {info?.for_kids && info?.for_men && info?.for_women ? (
                        <Tooltip title="مناسب خانواده" arrow>
                            <Icon name="FamilyIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    ) : null}
                    {info?.for_kids && (!info?.for_men || !info?.for_women) ? (
                        <Tooltip title="مناسب کودکان" arrow>
                            <Icon name="ChildIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    ) : null}
                    {info?.for_men && (!info?.for_kids || !info?.for_women) ? (
                        <Tooltip title="مناسب آقایان" arrow>
                            <Icon name="ManIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    ) : null}
                    {info?.for_women && (!info?.for_kids || !info?.for_kids) ? (
                        <Tooltip title="مناسب بانوان" arrow>
                            <Icon name="WomanIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    ) : null}
                    {!info?.for_adults ? (
                        <Tooltip title="نامناسب برای بزرگسالان" arrow>
                            <Icon name="AdultIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    ) : null}
                    {info?.has_dedicated_restaurant && (
                        <Tooltip title="دارای رستوران یا فست فود" arrow>
                            <Icon name="FoodIcon" style={{ cursor: "pointer" }} />{" "}
                        </Tooltip>
                    )}
                </Grid>

                <Grid container item xs={12} justifyContent="space-between">
                    <Grid container item xs={2.5} justifyContent="center" alignItems="center">
                        <BaseButton
                            color="secondary"
                            size="small"
                            radius="radius-50"
                            rightIcon={<Icon name="DetailsIcon" />}
                            handleClick={() => handleDescriptionModal(info, index)}
                        />
                    </Grid>
                    <Grid container item xs={8} justifyContent="center" alignItems="center">
                        {!isExpire && (
                            <BaseButton
                                text={` ${t("replace")} `}
                                color="primary"
                                size="small"
                                radius="radius-10"
                                rightIcon={<ArrowSwapHorizontal color="var(--light-color)" />}
                                handleClick={() => handleReplaceModal(info)}
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid className="itinerary-item__lottie" container item xs={2} display={index === length - 1 ? "none" : "flex"} alignItems="center">
                <div>
                    <Lottie options={defaultOptions} />
                </div>
            </Grid>
        </Grid>
    );
}

export default ItineraryItem;
